/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcTradereportingV1CatReportEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_TRADEREPORTING_V1_CAT_REPORT_EVENT_ENTITY_NAME = 'ixc.tradereporting.v1.CatReportEvent';
export const ixcTradereportingV1CatReportEventEntity = new schema.Entity<IxcTradereportingV1CatReportEvent>(IXC_TRADEREPORTING_V1_CAT_REPORT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcTradereportingV1CatReportEvent) => `${entity.metadata?.eventId}` });

